<base-modal-component (onConfirm)="save()" [validation]="isValid()" class="base-modal">
    <fields-list-component [fields]="fields" [value]="message" name="user_messages_edit"></fields-list-component>
</base-modal-component>
